export default __webpack_public_path__ + "locales/ko-KR/Settings.json?hash=9ad1b76ef2c70206f8995c78b24bba9b";